<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="animated fadeIn vld-parent pb-1" style="height: 100%; background-color: #fcfcfc">
        <b-row>
            <b-col>
                <div style=" padding: 5px 32px 4px;border-bottom: 1px solid gray; ">
                    <b-row>
                        <b-col md="3" style="padding: 7px" class="my-auto">
                            <span style="font-weight: bolder">Maßnahme für Baum Nr.: {{tree_number}} </span>
                        </b-col>
                        <b-col>
                          <b-button variant="primary" v-if="canGoBack" v-on:click="goBack" class="px-4 float-right ml-3">Zurück</b-button>

                          <b-dropdown v-if="!isExternal" id="dropdown-1" text="Drucken" class="float-right ml-3" variant="primary">
                              <b-dropdown-item :href="hrefTask" target="_blank">Maßnahme</b-dropdown-item>
                                <b-dropdown-item :href="hrefTaskImgDetail" target="_blank">Maßnahme + Detailbild</b-dropdown-item>
                                <b-dropdown-item :href="hrefTaskControl" target="_blank">Kontrolle + Maßnahme</b-dropdown-item>
                                <b-dropdown-item :href="hrefTaskControlImgDetail" target="_blank">Kontrolle + Maßnahme + Detailbild</b-dropdown-item>
                                <b-dropdown-item :href="hrefTaskTree" target="_blank">Baumstammblatt + Maßnahme</b-dropdown-item>
                                <b-dropdown-item :href="hrefTaskTreeImgDetail" target="_blank">Baumstammblatt + Maßnahme + Detailbild</b-dropdown-item>
                                <b-dropdown-item :href="hrefTaskControlTree" target="_blank">Baumstammblatt + Kontrolle + Maßnahme</b-dropdown-item>
                                <b-dropdown-item :href="hrefTaskControlTreeImgDetail" target="_blank">Baumstammblatt + Kontrolle + Maßnahme + Detailbild</b-dropdown-item>
                            </b-dropdown>
                            <b-button-group style="float: right" v-if="!isExternal">
                                <b-button variant="primary" class="px-4" style="border-right: 1px solid lightgray;" v-on:click="gotoTree">Baum
                                </b-button>
                                <b-button variant="primary" class="px-4" style="border-left: 1px solid lightgray; border-right: 1px solid lightgray" v-on:click="gotoControls">Kontrollen
                                </b-button>
                                <b-button variant="primary" class="px-4" style="border-left: 1px solid lightgray;" v-on:click="gotoTasks">Alle Maßnahmen
                                </b-button>
                            </b-button-group>
                            <b-button-group style="float: right" v-if="isExternal">
                                <b-button variant="primary" class="px-4" v-on:click="gotoTree">Zum Baum
                                </b-button>
                            </b-button-group>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
        </b-row>
        <b-row style="padding-top: 1rem; padding-left: 15px; padding-right: 15px">
            <b-col md="6" style="padding-right: 7px">
                <md-card>
                    <md-card-header style="border-bottom: 1px solid lightgray;">
                        <span style="color: darkslategrey"><b>Massnahme</b></span>
                    </md-card-header>
                    <md-card-content style="margin-top: 16px">
                        <b-row>
                            <b-col class="my-auto"><span>Name:</span></b-col>
                            <b-col>
                                <b-form-input
                                        class="black"
                                        :minMatchingChars="0"
                                        placeholder=""
                                        v-model="task.name"
                                        :disabled="disabled"
                                />
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col class="my-auto"><span>Textbaustein:</span></b-col>
                            <b-col>
                                <b-form-input
                                        class="black"
                                        :minMatchingChars="0"
                                        placeholder=""
                                        v-model="task.task_sub_type"
                                        :disabled="disabled"

                                />
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col class="my-auto"><span>Einfluss auf Verkehrssicherheit:</span></b-col>
                            <b-col>
                                <b-form-input class="form-control black"
                                              placeholder=""
                                              v-model="task.security_relevance"
                                              :disabled="disabled"

                                ></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col class="my-auto"><span>Hilfsmittel:</span></b-col>
                            <b-col>
                                <b-form-input class="form-control black"
                                              placeholder=""
                                              v-model="task.tools"
                                              :disabled="disabled"

                                ></b-form-input>
                            </b-col>
                        </b-row>

                        <b-row class="mt-2">
                            <b-col class="my-auto"><span>Priorität:</span></b-col>
                            <b-col>
                                <b-form-input class="form-control black"
                                              placeholder=""
                                              v-model="task.priority"
                                              :disabled="disabled"

                                ></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col class="my-auto"><span>Erstellt am:</span></b-col>
                            <b-col>
                                <b-form-input class="form-control black"
                                              placeholder=""
                                              v-model="task.create_date"
                                              :disabled="disabled"

                                ></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col class="my-auto"><span>Fertiggestellt am:</span></b-col>
                            <b-col>
                                <b-form-input class="form-control black"
                                              placeholder=""
                                              v-model="task.finish_date"
                                              :disabled="disabled"

                                ></b-form-input>
                            </b-col>
                        </b-row>
                    </md-card-content>
                </md-card>
                <md-card>
                    <md-card-header style="border-bottom: 1px solid lightgray;">
                        <span style="color: darkslategrey"><b>Zusatz Informationen</b></span>
                    </md-card-header>
                    <md-card-content style="margin-top: 16px">
                        <b-row>
                            <b-col md="6" lg="8">
                                <span style="margin-left: 6px;">Maßnahmenbeschreibung:</span>
                                <b-form-textarea style="margin-top: 16px"
                                                 placeholder=""
                                                 rows="10"
                                                 no-resize
                                                 v-model="task.note"
                                                 :disabled="disabled"
                                                 class="black"

                                ></b-form-textarea>
                            </b-col>
                            <b-col md="6" lg="4">
                                <span style="margin-left: 18px">Fotos:</span>
                                <carousel style="margin-top: 16px; height: 255px" :per-page="1" :mouse-drag="false" :center-mode="true">
                                    <slide v-for="(slide, index) in images" :key="slide" class="hoverable-icon">
                                        <img style="height: 241px; object-fit: cover" :src="slide" v-on:click="slideClicked(index)" />
                                    </slide>
                                </carousel>

                            </b-col>
                        </b-row>
                    </md-card-content>
                </md-card>
            </b-col>
            <b-col md="6" style="padding-right: 7px">
                <md-card >
                    <md-card-header style="border-bottom: 1px solid lightgray;">
                        <b-row>
                            <b-col class="my-auto">
                                <span style="color: darkslategrey"><b>Karte</b></span>
                            </b-col>
                        </b-row>
                    </md-card-header>
                    <md-card-content style="margin-top: 0px; padding-bottom: 0">
                        <b-row style="margin-bottom: 0">
                            <b-col style="height: 60vh; padding: 0; margin-bottom: 0" id="map_container"
                                   ref="map_container">
                            </b-col>
                        </b-row>
                    </md-card-content>
                </md-card>
            </b-col>
        </b-row>
        <b-row style="padding-top: 1rem; padding-left: 15px; padding-right: 15px">
            <b-col>
                <b-button-group>
                    <b-button variant="success" :disabled="fertigstellen_disabled" v-if="!isExternal || hasPermissionExternal" class="px-4" style="border-right: 1px solid lightgray;" v-on:click="finishTask">{{fertigstellen_text}}
                    </b-button>
                    <b-button variant="primary" v-if="!task.is_planned && planable && !isExternal" class="px-4" style="border-left: 1px solid lightgray; border-right: 1px solid lightgray" v-on:click="planTask(task_id)">Beplanen
                    </b-button>
                    <b-button variant="primary" v-if="!task.is_planned && sendable && !isExternal" class="px-4" style="border-left: 1px solid lightgray; border-right: 1px solid lightgray" v-on:click="planTask(task_id)">Versenden
                    </b-button>
                    <b-button variant="danger" v-if="!isExternal" class="px-4" style="border-left: 1px solid lightgray;" v-on:click="deleteTask">Löschen
                    </b-button>
                </b-button-group>

            </b-col>
        </b-row>
        <CoolLightBox
                :items="images"
                :index="index"
                @close="index = null">
        </CoolLightBox>
        <modal name="text"
               :height="'auto'"
               adaptive>
            <p style="padding-top: 12px; padding-left: 12px; margin-bottom: 0.5rem"><strong>Notiz:</strong></p>
            <p style="padding: 12px">{{text}}</p>
        </modal>

        <b-modal
                centered
                v-model="show_delete"
                title="Maßnahme löschen"
                cancel-title="Abbrechen"
                ok-title="Löschen"
                @ok="onDelete"
                ok-variant="danger"
        >Möchten Sie diese Maßnahme wirklich löschen ?<br>Dies kann nicht rückgängig gemacht werden.</b-modal>
        <b-modal
                centered
                v-model="show_finish"
                title="Maßnahme fertigstellen"
                cancel-title="Abbrechen"
                ok-title="Fertigstellen"
                @ok="onFinish"

                ok-variant="success"
        >Möchten Sie diese Maßnahme fertigstellen ?<br>Dies kann nicht rückgängig gemacht werden.</b-modal>

        <b-modal
                centered
                v-model="show_plan"
                title="Maßnahme beplanen"
                cancel-title="Abbrechen"
                ok-title="Zuweisen"
                @ok="onPlan"
                @hide="resetPlanning"
                ok-variant="info"
        >
            <b-row>
                <b-col md="3"></b-col>
                <b-col>
                    <p style="margin-bottom: 0.5rem">Datum:</p>
                    <datetime
                            v-model="taskDate"
                            input-class="form-control"
                            input-style="color: black;"
                            :phrases="datetimeConfig.phrases"
                            :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                            :min-datetime="datetimeConfig.minTime"
                            placeholder="Datum"
                            style="margin-bottom: 1rem"
                    ></datetime>
                    <p style="margin-bottom: 0.5rem">Mitarbeitergruppe:</p>
                    <b-form-select class="black" plain
                                   :options="taskGroups"
                                   v-model="taskGroup">
                        <template v-slot:first>
                            <b-form-select-option :value="null">-- Gruppe auswählen --
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col md="3"></b-col>
            </b-row>
        </b-modal>

        <b-modal
                centered
                v-model="show_send"
                title="Maßnahme versenden"
                cancel-title="Abbrechen"
                ok-title="Versenden"
                @ok="onSend"
                ok-variant="info"
        >
            <b-row>
                <b-col md="3"></b-col>
                <b-col>
                    <p style="margin-bottom: 0.5rem">Möchten Sie diese Maßnahme an BIS-Office übergeben ?</p>
                </b-col>
                <b-col md="3"></b-col>
            </b-row>
        </b-modal>

        <beautiful-chat
                v-if="chatId !== null  && false"
                :participants="participants"
                :onMessageWasSent="onMessageWasSent"
                :messageList="messageList"
                :newMessagesCount="newMessagesCount"
                :isOpen="isChatOpen"
                :close="closeChat"
                :open="openChat"
                :showEmoji="false"
                :showFile="false"
                :showTypingIndicator="showTypingIndicator"
                :showLauncher="true"
                :showCloseButton="true"
                :colors="colors"
                :alwaysScrollToBottom="alwaysScrollToBottom"
                :messageStyling="messageStyling"
                placeholder="Nachricht schreiben..."
        >
            <template v-slot:header>
                <p style="margin: auto; text-align: center; font-weight: bold">Teilnehmer: <span style="font-weight: normal">{{participants.map(m=>m.name).join(', ')}}</span></p>
            </template>
            <template v-slot:user-avatar="{ message, user }">
                <div>
                </div>
            </template>
            <template v-slot:text-message-body="{ message }">
                <p style='font-weight: bold; margin-bottom: 3px; font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; margin-left: -12px'>
                    {{message.data.meta_name}}:
                </p>
                <p style="margin-left: -12px; margin-bottom: 8px">{{message.data.text}}</p>
                <p style="text-align: right; font-weight: lighter; font-size: 12px; margin-bottom: 0px; margin-top: 8px; margin-right: -12px">
                    {{message.data.meta}}
                </p>
            </template>
            <template v-slot:text-message-toolbox="{ message }">
            </template>
        </beautiful-chat>
    </div>
</template>

<script>
    import {Server_URL, Server_URL_BASE} from "../../shared/utils";
    import ImageIcon from 'vue-material-design-icons/Image.vue';
    import TextIcon from 'vue-material-design-icons/CommentText.vue';
    import CoolLightBox from 'vue-cool-lightbox'
    import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'


    import DeleteIcon from 'vue-material-design-icons/Delete.vue';
    import CheckIcon from 'vue-material-design-icons/CheckCircle';
    import PlanIcon from 'vue-material-design-icons/AccountMultipleCheck';

    import {DateTime as LuxonDateTime} from 'luxon'
    import { Carousel, Slide } from 'vue-carousel';

    import StylesControl from 'mapbox-gl-controls/lib/styles';
    import ZoomControl from 'mapbox-gl-controls/lib/zoom';
    import LanguageControl from 'mapbox-gl-controls/lib/language';
    import MapboxGeocoder from 'mapbox-gl-geocoder';
    import mapboxgl from 'mapbox-gl/dist/mapbox-gl';


    export default {
        name: "controls",
        components: {
            ImageIcon,
            TextIcon,
            CoolLightBox,
            DeleteIcon,
            CheckIcon,
            PlanIcon,
            Carousel,
            Slide
        },
        mounted() {
          this.canGoBack = window.history.length > 1;
          if (this.$route.query.customer_external !== undefined && this.$route.query.customer_external !== "") {
                this.isExternal = true;
                if (this.$route.query.permission !== undefined && this.$route.query.permission !== "") {
                    this.hasPermissionExternal = true;
                }
            }
            this.task_id = this.$route.params.id;
            this.showLoader();
            this.$http.get(
                Server_URL + '/baumkontrolle/get/task/'+this.$route.params.id
            ).then(this.responseOkGet, this.responseError)
        },
        data() {
            return {
              canGoBack: false,
              no_tasks: false,
                index: null,
                text: "",
                loader: undefined,
                disabled: true,

                items: [],
                tree_number: "",
                task_id: "",
                task: {},
                currentTask: null,
                show_delete: false,
                show_finish: false,
                show_plan: false,
                datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, minTime: LuxonDateTime.local().toISO()},
                taskDate: null,
                taskGroup: null,
                taskGroups: [{text: "Baumkontrolle", value: ""}],
                images: [],
                participants: [], // the list of all the participant of the conversation. `name` is the user name, `id` is used to establish the author of a message, `imageUrl` is supposed to be the user avatar.
                messageList: [], // the list of the messages to show, can be paginated and adjusted dynamically
                newMessagesCount: 0,
                isChatOpen: true, // to determine whether the chat window should be open or closed
                showTypingIndicator: '', // when set to a value matching the participant.id it shows the typing indicator for the specific user
                colors: {
                    header: {
                        bg: '#4e8cff',
                        text: '#ffffff'
                    },
                    launcher: {
                        bg: '#4e8cff'
                    },
                    messageList: {
                        bg: '#ffffff'
                    },
                    sentMessage: {
                        bg: '#4e8cff',
                        text: '#ffffff'
                    },
                    receivedMessage: {
                        bg: '#eaeaea',
                        text: '#222222'
                    },
                    userInput: {
                        bg: '#f4f7f9',
                        text: '#565867'
                    }
                }, // specifies the color scheme for the component
                alwaysScrollToBottom: true, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
                messageStyling: false, // enables *bold* /emph/ _underline_ and such (more info at github.com/mattezza/msgdown)

                customerNumber: "9996668",
                chatId: null,
                userToken: "DEULA",
                interval: null,
                lat: null,
                lon: null,

                geocoder: null,
                map: {},
                marker: null,
                in_map_mode: false,

                fertigstellen_disabled: false,
                fertigstellen_text: "Fertigstellen",
                planable: true,
                sendable: false,
                show_send: false,
                isExternal: false,
                hasPermissionExternal: false,
            }
        },
        computed: {
            latLon: function () {
                if (this.lat != null && this.lon != null) {
                    return this.lat.toString() + ", " + this.lon.toString();
                } else {
                    return "";
                }
            },
            hrefTask: function () {
                return Server_URL + '/baumkontrolle/tree/pdf?task_id='+this.task_id
            },
            hrefTaskImgDetail: function () {
                return Server_URL + '/baumkontrolle/tree/pdf?task_id='+this.task_id + "&image_detail=true"
            },
            hrefTaskTree: function () {
                return Server_URL + '/baumkontrolle/tree/pdf?task_id='+this.task_id+"&tree_id="+this.task.tree_id
            },
            hrefTaskTreeImgDetail: function () {
                return Server_URL + '/baumkontrolle/tree/pdf?task_id='+this.task_id+"&tree_id="+this.task.tree_id+ "&image_detail=true"
            },
            hrefTaskControl: function () {
                return Server_URL + '/baumkontrolle/tree/pdf?task_id='+this.task_id+"&control_id="+this.task.control_id
            },
            hrefTaskControlImgDetail: function () {
                return Server_URL + '/baumkontrolle/tree/pdf?task_id='+this.task_id+"&control_id="+this.task.control_id+ "&image_detail=true"
            },
            hrefTaskControlTree: function () {
                return Server_URL + '/baumkontrolle/tree/pdf?task_id='+this.task_id+"&tree_id="+this.task.tree_id+"&control_id="+this.task.control_id
            },
            hrefTaskControlTreeImgDetail: function () {
                return Server_URL + '/baumkontrolle/tree/pdf?task_id='+this.task_id+"&tree_id="+this.task.tree_id+"&control_id="+this.task.control_id+ "&image_detail=true"
            }
        },
        methods: {
          goBack(){
            this.$router.go(-1);
          },
            slideClicked(index) {
                this.index = index;
            },
            gotoTasks() {
                this.$router.push({ path: `/tree/tasks/${this.task.tree_id}` })
            },
            gotoTree() {
                let query = "";
                if (this.isExternal) {
                    query += "?customer_external=" + this.$route.query.customer_external + "&external_key=" + this.$route.query.external_key
                    if (this.hasPermissionExternal) {
                        query += "&permission=" + this.$route.query.permission
                    }
                }
                this.$router.push("/tree/show/"+this.task.tree_id+query)
            },
            gotoControls() {
                this.$router.push({ path: `/tree/controls/${this.task.tree_id}` })
            },
            showImage(image, taskId) {
                let imgs = image.split("||");
                this.images = [];
                for (let i = 0; i < imgs.length; i++) {
                    if (imgs[i] !== "") {
                        this.images.push(Server_URL + '/baumkontrolle/task/image' + "?task_id=" + taskId + "&image_name=" + imgs[i]+"_x2.jpeg");
                    }
                }
                this.index = 0;
            },
            showText(text) {
                this.text = text;
                this.$modal.show('text');
            },
            showLoader() {
                if (this.loader === undefined) {
                    this.loader = this.$loading.show();
                }
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            responseError(response) {
                this.hideLoader();
                if (response.status === 401) {
                    console.log(response);
                } else {
                    console.log(response);
                }
            },
            responseOkGet(response) {
                this.hideLoader();
                if (response.status === 200) {
                    this.task = response.data.task;
                    this.lat = response.data.lat;
                    this.lon = response.data.lon;
                    this.tree_number = this.task.tree_number;
                    this.planable = response.data.planable;
                    this.sendable = response.data.sendable;
                    if (this.task.security_relevance) {
                        this.task.security_relevance = "Ja";
                    } else {
                        this.task.security_relevance = "Nein";
                    }
                    this.task.create_date = this.dateFormater(this.task.create_date);
                    this.task.finish_date = this.dateFormater(this.task.finish_date);
                    switch (this.task.priority) {
                        case 1:
                            this.task.priority = "Niedrig";
                            break;
                        case 2:
                            this.task.priority = "Mäßig";
                            break;
                        case 3:
                            this.task.priority = "Hoch";
                            break;
                    }
                    let imgs = this.task.image_url.split("||");
                    this.images = [];
                    for (let i = 0; i < imgs.length; i++) {
                        if (imgs[i] !== "") {
                            this.images.push(Server_URL + '/baumkontrolle/task/image' + "?task_id=" + this.task.id + "&image_name=" + imgs[i]+"_x2.jpeg");
                        }
                    }
                    this.task.tools = this.formateTools(this.task.tools);
                    if (this.task.chat_id !== null && this.task.chat_id !== "" && !this.isExternal) {
                        this.chatId = this.task.chat_id;
                        this.$http.get(
                            Server_URL_BASE + '/chat/complete/' + this.customerNumber + "?chat_id="+this.chatId+"&token="+this.userToken
                        ).then(this.responseOkChat, this.responseError)
                    }
                    this.fertigstellen_disabled = this.task.finish_date !== "";
                    this.fertigstellen_text = this.fertigstellen_disabled ? "Fertiggestellt" : "Fertigstellen";

                    for (let i = 0; i < response.body.user_groups.length; i++) {
                        this.taskGroups.push({text: response.body.user_groups[i], value: response.body.user_groups[i]})
                    }

                    this.toggleMapMode();
                } else {
                    console.log(response);
                }
            },
            responseOkReload(response) {
                this.hideLoader();
                if (response.status === 200) {
                    if (this.currentTask === "delete") {
                        this.$router.go(-1);
                    } else {
                        this.$http.get(
                            Server_URL + '/baumkontrolle/get/task/' + this.$route.params.id
                        ).then(this.responseOkGet, this.responseError)
                    }
                } else {
                    console.log(response);
                }
            },
            formateTools(value) {
                if (value === null || value === "") {
                    return ""
                }
                let res = value.split("||");
                let ret = res[0];
                for (let i = 1; i < res.length; i++) {
                    if (res[i] !== "") {
                        ret += ", " + res[i];
                    }
                }
                console.log(ret);
                return ret;

            },
            formateBool(value) {
                if (value === true) {
                    return "Ja"
                }  else {
                    return "Nein"
                }
            },
            dateFormater(value) {
                if (value === null) {
                    return ""
                }
                let event = new Date(value.replace('Z',''));
                let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
                return event.toLocaleDateString('de-DE', options);
            },

            deleteTask() {
                this.currentTask = this.task_id;
                this.show_delete = true;
            },
            onDelete() {
                if (this.currentTask !== null) {
                    this.showLoader();
                    this.$http.delete(
                        Server_URL + '/baumkontrolle/task/' + this.currentTask
                    ).then(this.responseOkReload, this.responseError);
                    this.currentTask = "delete";
                }
            },

            finishTask() {
                this.currentTask = this.task_id;
                this.show_finish = true;
            },
            onFinish() {
                if (this.currentTask !== null) {
                    this.showLoader();
                    this.$http.patch(
                        Server_URL + '/baumkontrolle/task/' + this.currentTask
                    ).then(this.responseOkReload, this.responseError);
                    this.currentTask = null;
                }
            },

            planTask(id) {
                if (this.planable) {
                    this.currentTask = id;
                    this.show_plan = true;
                } else if (this.sendable) {
                    this.currentTask = id;
                    this.show_send = true;
                }
            },
            onPlan(event) {
                if (this.taskDate === null || this.taskDate === "" || this.taskGroup === null) {
                    event.preventDefault();
                    this.$bvToast.toast(`Bitte wählen Sie ein Datum UND eine Mitarbeitergruppe aus.`, {
                        title: 'Speichern nicht möglich',
                        autoHideDelay: 3000,
                        appendToast: false,
                        toaster: 'b-toaster-top-center',
                    });
                    return;
                }
                if (this.currentTask !== null) {
                    this.showLoader();
                    let req = {
                        task: this.currentTask,
                        plan_for: this.taskGroup,
                        date: this.taskDate
                    };
                    console.log(req);
                    this.$http.post(
                        Server_URL + '/baumkontrolle/task/plan', req
                    ).then(this.responseOkReload, this.responseError);
                }
            },
            onSend(event) {
                if (this.currentTask !== null) {
                    this.showLoader();
                    let req = {
                        task: this.currentTask,
                        plan_for: "BIS_OFFICE",
                        date: new Date()
                    };
                    console.log(req);
                    this.$http.post(
                        Server_URL + '/baumkontrolle/task/plan', req
                    ).then(this.responseOkReload, this.responseError);
                }
            },
            resetPlanning() {
                this.currentTask = null;
                this.taskGroup = null;
                this.taskDate = null;
            },
            onMessageWasSent(message) {
                // called when the user sends a message
                if (this.interval !== null) {
                    clearInterval(this.interval);
                    this.interval = null;
                }
                let body = {
                    token: this.userToken,
                    chat_id: this.chatId,
                    message: message.data.text,
                };
                if (this.messageList.length > 0) {
                    body.last_date = this.messageList[this.messageList.length-1].data.meta_date;
                }
                this.$http.post(
                    Server_URL_BASE + '/chat/message/' + this.customerNumber, body
                ).then(this.responseOkChat, this.responseError)
            },
            openChat() {
                // called when the user clicks on the fab button to open the chat
                this.isChatOpen = true
                this.newMessagesCount = 0
            },
            closeChat() {
                // called when the user clicks on the botton to close the chat
                this.isChatOpen = false
            },
            responseOkChat(response) {
                if (response.status === 200) {
                    if (response.body.users !== undefined) {
                        for (let i = 0; i < response.body.users.length; i++) {
                            this.participants.push(response.body.users[i]);
                        }
                    }
                    for (let i = 0; i < response.body.messages.length; i++) {
                        this.messageList.push(response.body.messages[i]);
                    }
                    this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + response.body.messages.length;
                    if (this.interval === null) {
                        this.interval = setInterval(this.refresh, 2000);
                    }
                } else {
                    console.log(response);
                }
            },
            refresh() {
                let url = Server_URL_BASE + '/chat/update/' + encodeURIComponent(this.customerNumber) + "?chat_id="+encodeURIComponent(this.chatId)+"&token="+encodeURIComponent(this.userToken);
                if (this.messageList.length != 0) {
                    url += "&last_date=" + encodeURIComponent(this.messageList[this.messageList.length-1].data.meta_date);
                }
                this.$http.get(
                    url
                ).then(this.responseOkChat, this.responseError)
            },
            toggleMapMode() {
                    setTimeout(() => {
                        mapboxgl.accessToken = 'pk.eyJ1Ijoic3ZlbnBldGVyc2VuIiwiYSI6ImNqc3Z0YW82dDBhbDE0NXFpOGRzOXI4NWsifQ.Sq1nJiC3uKfA5yfYN8wR9w';
                        this.map = new mapboxgl.Map({
                            container: 'map_container',
                            style: 'mapbox://styles/mapbox/satellite-streets-v11',
                            center: [10.244990, 50.943359],
                            zoom: 6,
                            minZoom: 5,
                            maxPitch: 0,
                        });

                        this.map.addControl(new StylesControl({
                            styles: [
                                {
                                    label: 'Normal',
                                    styleName: 'Mapbox Streets',
                                    styleUrl: 'mapbox://styles/mapbox/outdoors-v11',
                                }, {
                                    label: 'Satellit',
                                    styleName: 'Satellite',
                                    styleUrl: 'mapbox://styles/mapbox/satellite-streets-v11',
                                },
                            ],
                        }), 'top-left');
                        this.map.addControl(new ZoomControl(), 'bottom-right');
                        const languageControl = new LanguageControl({
                            language: 'de',
                        });
                        this.map.addControl(languageControl);
                        this.geocoder = new MapboxGeocoder({
                            accessToken: mapboxgl.accessToken,
                            mapboxgl: mapboxgl,
                            placeholder: "Suchen"
                        });
                        this.map.addControl(
                            this.geocoder
                        );

                        //this.map.on('click', this.onMapClick);
                        this.map.once('load', this.queryPlace)
                    });
            },
            queryPlace() {
                if (this.lat !== null && this.lon !== null) {
                    let el = document.createElement('div');
                    el.className = 'marker';

                    this.marker = new mapboxgl.Marker({
                        element: el,
                        anchor: 'bottom',
                    })
                        .setLngLat([this.lon, this.lat])
                        .addTo(this.map);
                    this.map.flyTo({
                        center: [
                            this.lon,
                            this.lat
                        ],
                        zoom: 18,
                        essential: true // this animation is considered essential with respect to prefers-reduced-motion
                    });
                }
            },
        }
    }
</script>
<style>
    .marker {
        background-image: url('../../../public/tree_marker.png');
        background-size: cover;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        cursor: pointer;
    }
    .md-card {
        z-index: unset;
    }
    .sc-message {
        width: 340px;
    }
    .sc-message--text .sc-message--toolbox {
        display: none;
    }
    .VueCarousel-dot-container {
        margin-top: 0px !important;
    }

    .VueCarousel-dot {
        margin-top: 0 !important;
    }

    .custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
        background-color: rgb(66, 139, 202);
    }

    .black {
        color: #000;
    }

    .modal-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .modal-container {
        display: inline-block;
        width: auto;
    }
    .no-border th {
        border-top: none;
    }
    .sc-chat-window {
        z-index: 200 !important;
    }
</style>
<style scoped>
    .hoverable:hover {
        color: #23282c;
        background-color: rgba(0, 0, 0, 0.075);
        cursor: pointer;
    }

    .hoverable-icon:hover {
        cursor: pointer;
    }
</style>
